/* tslint:disable */
/* eslint-disable */
/**
 * Dataland Community Manager API documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../../../../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../../../../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../../../../../base';
// @ts-ignore
import type { EmailAddress } from '../../../../../../org/dataland/datalandfrontend/openApiClient/communitymanager/model';
// @ts-ignore
import type { ErrorResponse } from '../../../../../../org/dataland/datalandfrontend/openApiClient/communitymanager/model';
// @ts-ignore
import type { KeycloakUserInfo } from '../../../../../../org/dataland/datalandfrontend/openApiClient/communitymanager/model';
/**
 * EmailAddressControllerApi - axios parameter creator
 */
export const EmailAddressControllerApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns all users whose email address contains one of the subdomains listed in the associatedSubdomains field of the corresponding CompanyInformation object.
         * @summary Get users by company-associated subdomains.
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByCompanyAssociatedSubdomains: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('getUsersByCompanyAssociatedSubdomains', 'companyId', companyId)
            const localVarPath = `/emails/{companyId}/recommended-users`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Based on an email address, learn if there is a Dataland user with that email address and if so, obtain their Dataland user ID, first and last name.
         * @summary Validate an email address and obtain user-related information from an email address.
         * @param {EmailAddress} emailAddress 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEmailAddressValidation: async (emailAddress: EmailAddress, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailAddress' is not null or undefined
            assertParamExists('postEmailAddressValidation', 'emailAddress', emailAddress)
            const localVarPath = `/emails/validation`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication default-bearer-auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            // authentication default-oauth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "default-oauth", [], configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailAddress, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * EmailAddressControllerApi - functional programming interface
 */
export const EmailAddressControllerApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = EmailAddressControllerApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns all users whose email address contains one of the subdomains listed in the associatedSubdomains field of the corresponding CompanyInformation object.
         * @summary Get users by company-associated subdomains.
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersByCompanyAssociatedSubdomains(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<KeycloakUserInfo>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersByCompanyAssociatedSubdomains(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailAddressControllerApi.getUsersByCompanyAssociatedSubdomains']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Based on an email address, learn if there is a Dataland user with that email address and if so, obtain their Dataland user ID, first and last name.
         * @summary Validate an email address and obtain user-related information from an email address.
         * @param {EmailAddress} emailAddress 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postEmailAddressValidation(emailAddress: EmailAddress, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<KeycloakUserInfo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postEmailAddressValidation(emailAddress, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['EmailAddressControllerApi.postEmailAddressValidation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * EmailAddressControllerApi - factory interface
 */
export const EmailAddressControllerApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = EmailAddressControllerApiFp(configuration)
    return {
        /**
         * Returns all users whose email address contains one of the subdomains listed in the associatedSubdomains field of the corresponding CompanyInformation object.
         * @summary Get users by company-associated subdomains.
         * @param {string} companyId The unique identifier under which a company can be found on Dataland.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByCompanyAssociatedSubdomains(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<KeycloakUserInfo>> {
            return localVarFp.getUsersByCompanyAssociatedSubdomains(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Based on an email address, learn if there is a Dataland user with that email address and if so, obtain their Dataland user ID, first and last name.
         * @summary Validate an email address and obtain user-related information from an email address.
         * @param {EmailAddress} emailAddress 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postEmailAddressValidation(emailAddress: EmailAddress, options?: RawAxiosRequestConfig): AxiosPromise<KeycloakUserInfo> {
            return localVarFp.postEmailAddressValidation(emailAddress, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * EmailAddressControllerApi - interface
 */
export interface EmailAddressControllerApiInterface {
    /**
     * Returns all users whose email address contains one of the subdomains listed in the associatedSubdomains field of the corresponding CompanyInformation object.
     * @summary Get users by company-associated subdomains.
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsersByCompanyAssociatedSubdomains(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<KeycloakUserInfo>>;

    /**
     * Based on an email address, learn if there is a Dataland user with that email address and if so, obtain their Dataland user ID, first and last name.
     * @summary Validate an email address and obtain user-related information from an email address.
     * @param {EmailAddress} emailAddress 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    postEmailAddressValidation(emailAddress: EmailAddress, options?: RawAxiosRequestConfig): AxiosPromise<KeycloakUserInfo>;

}

/**
 * EmailAddressControllerApi - object-oriented interface
 */
export class EmailAddressControllerApi extends BaseAPI implements EmailAddressControllerApiInterface {
    /**
     * Returns all users whose email address contains one of the subdomains listed in the associatedSubdomains field of the corresponding CompanyInformation object.
     * @summary Get users by company-associated subdomains.
     * @param {string} companyId The unique identifier under which a company can be found on Dataland.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getUsersByCompanyAssociatedSubdomains(companyId: string, options?: RawAxiosRequestConfig) {
        return EmailAddressControllerApiFp(this.configuration).getUsersByCompanyAssociatedSubdomains(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Based on an email address, learn if there is a Dataland user with that email address and if so, obtain their Dataland user ID, first and last name.
     * @summary Validate an email address and obtain user-related information from an email address.
     * @param {EmailAddress} emailAddress 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public postEmailAddressValidation(emailAddress: EmailAddress, options?: RawAxiosRequestConfig) {
        return EmailAddressControllerApiFp(this.configuration).postEmailAddressValidation(emailAddress, options).then((request) => request(this.axios, this.basePath));
    }
}

